import { DeliveryNotesDetailsEffect } from './delivery-notes-details.effect';
import { DeliveryNotesOverviewEffect } from './delivery-notes-overview.effect';

export const effects: any[] = [
  DeliveryNotesOverviewEffect,
  DeliveryNotesDetailsEffect
];
